import { render, staticRenderFns } from "./PPCCenter.vue?vue&type=template&id=4178daac&"
import script from "./PPCCenter.vue?vue&type=script&lang=js&"
export * from "./PPCCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports